import { apiGetUserInfo, getModules } from './../../apis/api'

const state = {
  userInfo: null,
  modules: null
}

const mutations = {
  addUser (state, userInfo) {
    state.userInfo = userInfo
  },
  addModules (state, modules) {
    state.modules = modules
  }
}

function getDevLoginBase () {
  return APPCONFIG.loginHost || APPCONFIG.host || 'https://hebei.tianditu.gov.cn'
}

function fetchUserViaJsonp (commit) {
  return new Promise((resolve, reject) => {
    if (typeof window.tdtUserLogin !== 'function') {
      reject(new Error('tdtUserLogin 不可用'))
      return
    }
    const loginBase = getDevLoginBase()
    window.tdtUserLogin(function (res) {
      if (res && (res.username || res.login_email)) {
        commit('addUser', res)
        resolve(res)
      } else {
        reject(new Error('未登录'))
      }
    }, {
      T_LOGIN: loginBase + '/tdtsso/login',
      T_LOGOUT: loginBase + '/tdtsso/logout',
      T_USER_INFO: loginBase + '/tdtsso/userInfo',
      HIDE_LOGIN: true
    }, window)
  })
}

function bindTdtUserLogin (commit) {
  if (!APPCONFIG.isTDT || typeof window.tdtUserLogin !== 'function') {
    return
  }
  window.tdtUserLogin(function (res) {
    if (res && res.username) {
      commit('addUser', res)
    }
  }, {
    T_LOGIN: APPCONFIG.tdthost + '/tdtsso/login',
    T_LOGOUT: APPCONFIG.tdthost + '/tdtsso/logout',
    T_USER_INFO: APPCONFIG.tdthost + '/tdtsso/userInfo',
    HIDE_LOGIN: true
  }, window)
}

const actions = {
  getUserInfo ({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await apiGetUserInfo()
        const data = res && res.data
        if (data && typeof data === 'object' && data.resultInfo && data.resultInfo.data) {
          commit('addUser', data.resultInfo.data)
          const url = 'module/permis/' + data.resultInfo.data.pkid + '.json'
          getModules(url).then((res) => {
            if (res.data && res.data.success && res.data.data && res.data.data.modules) {
              const root = res.data.data.modules[0]
              const child = root && root.children && root.children[0]
              if (child && child.children) {
                commit('addModules', child.children)
              }
            }
          }).catch(() => {})
          resolve(data.resultInfo.data)
        } else {
          reject(new Error('未获取到用户信息'))
        }
      } catch (err) {
        if (APPCONFIG.isLocalDev) {
          try {
            resolve(await fetchUserViaJsonp(commit))
            return
          } catch (jsonpErr) {
            reject(jsonpErr)
            return
          }
        }
        reject(err || new Error('获取用户信息失败'))
      }
      // 线上/build：保持原有 tdtUserLogin 逻辑
      if (!APPCONFIG.isLocalDev) {
        bindTdtUserLogin(commit)
      }
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js